import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuCircleFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.10302 5.10302C8.91238 1.29366 15.0876 1.29366 18.897 5.10302C22.7063 8.91238 22.7063 15.0876 18.897 18.897C15.0876 22.7063 8.91238 22.7063 5.10302 18.897C1.29366 15.0876 1.29366 8.91238 5.10302 5.10302ZM7.49812 8.24875C7.08391 8.24875 6.74812 8.58454 6.74812 8.99875C6.74812 9.41296 7.08391 9.74875 7.49812 9.74875H16.5019C16.9161 9.74875 17.2519 9.41296 17.2519 8.99875C17.2519 8.58454 16.9161 8.24875 16.5019 8.24875H7.49812ZM8.62359 11.7502C8.20938 11.7502 7.87359 12.086 7.87359 12.5002C7.87359 12.9144 8.20938 13.2502 8.62359 13.2502H15.3764C15.7906 13.2502 16.1264 12.9144 16.1264 12.5002C16.1264 12.086 15.7906 11.7502 15.3764 11.7502H8.62359ZM9.74906 15.2517C9.33485 15.2517 8.99906 15.5875 8.99906 16.0017C8.99906 16.4159 9.33485 16.7517 9.74906 16.7517H14.2509C14.6651 16.7517 15.0009 16.4159 15.0009 16.0017C15.0009 15.5875 14.6651 15.2517 14.2509 15.2517H9.74906Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgMenuCircleFilled);
export default ForwardRef;
